document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const quantityBox = document.querySelector(".mw-option.quantity-box");
    const howPersonalize = document.querySelector(".how-personalize-wrapper");

    if (quantityBox && howPersonalize) {
      quantityBox.insertAdjacentElement("afterend", howPersonalize);

      clearInterval(interval);
    }
  }, 300); // check every 300ms
});

const moveCheck = setInterval(() => {
  const comp = document.querySelector(".custom-complementary-products");
  const paper = document.querySelector(".paper-quality-block");

  if (comp && paper && paper.parentNode) {
    paper.parentNode.insertBefore(comp, paper.nextSibling);
    clearInterval(moveCheck);
  }
}, 300);



const priceCleaner = setInterval(() => {
  const options = document.querySelectorAll(".quantity-box select option");

  if (options.length > 0) {
    options.forEach(option => {
      option.textContent = option.textContent.replace(/\(\+DKK [0-9.,]+\)\s*$/, "");
    });

    clearInterval(priceCleaner);
    console.log("Price removed & interval cleared");
  }
}, 300);




document.addEventListener("DOMContentLoaded", function () {
  const ImageQuality = "imgIncreaseQuality_" + Math.random().toString(36).slice(2);

  window[ImageQuality] = setInterval(() => {
    const imgs = document.querySelectorAll(".mw-stack--card__media-wrapper--item img, .mw-stack--card__media-item--crop");

    if (!imgs.length) return;

    imgs.forEach((img) => {
      if (img.src.includes("width=") || img.src.includes("height=")) {
        img.src = img.src
          .replace(/width=\d+/i, "width=2000")
          .replace(/height=\d+/i, "height=2000");
      }
    });

    clearInterval(window[ImageQuality]);
    delete window[ImageQuality];
  }, 300);
});


document.querySelector('.add-cart-wrapper a.custom-add-to-cart')
?.addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('button.mw-apo-add-to-cart-custom')?.click();
});

